<template>
  <v-dialog
    class="rounded-lg"
    @update:model-value="closeModal"
    :model-value="modelValue"
    max-width="417"
    persistent
  >
    <v-card>
      <div class="image-container">
        <img :src="eventImage" alt="event banner" />
        <button @click="closeModal">
          <IconMaterial class="close-icon" color="#FFFFFF" icon="close" :size="24" />
        </button>
      </div>
      <div class="pt-4 px-7 pb-6">
        <div class="bold-subtitle-md mb-4 text-center">{{ eventName }}</div>
        <div class="d-flex ga-4 align-center justify-center mb-8">
          <div>
            <IconMaterial
              color="#64748B"
              icon="calendar_month"
              :size="16"
              class="mr-1"
              variant="outlined"
            />
            <span class="regular-body-sm">{{ eventDates }}</span>
          </div>
          <div>
            <IconMaterial
              color="#64748B"
              icon="watch_later"
              :size="16"
              class="mr-1"
              variant="outlined"
            />
            <span class="regular-body-sm">{{ eventTime }}</span>
          </div>
        </div>
        <div class="d-flex justify-center">
          <Button class="valor-blue" size="lg" text="Access Event" @click="goToEventPage" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';
import Button from '@design_system_v3/components/atoms/Button.vue';

const props = defineProps({
  modelValue: Boolean,
  eventName: String,
  eventDates: String,
  eventTime: String,
  eventNameId: String,
  bannerImageUrl: String,
});

const emits = defineEmits(['update:modelValue']);

const closeModal = () => {
  localStorage.setItem('event-modal-shown', props.eventNameId);
  emits('update:modelValue', false);
};

const goToEventPage = () => {
  localStorage.setItem('event-modal-shown', props.eventNameId);
  window.postMessage(
    {
      name: 'iConnectionsEventBus',
      type: 'changeMFe',
      path: `/event/details/${props.eventNameId}`,
    },
    '*',
  );
};

const isValorEvent = computed(() => {
  const valorEvents = ['ValorAGM-2025', 'VirtualAGM-2025'];
  return valorEvents.includes(props.eventNameId);
});

const eventImage = computed(() => (isValorEvent.value
  ? 'https://assets.iconnections.io/events/387/images/valor_centered.png'
  : props.bannerImageUrl));
</script>

<style scoped lang="scss">
@import '@foundation';

.image-container {
  position: relative;

  img {
    height: 150px;
  }
}

.close-icon {
  position: absolute;
  top: 12px;
  right: 12px;
}

.valor-blue {
  background-color: #2d3fe5 !important;
}
</style>
